import { View } from 'react-native';
import { ProfileChecklistCard } from './ProfileChecklistCard';
import { OnboardingGuideCard } from './OnboardingGuideCard';
import { AppRatingQuestCard } from './AppRatingQuestCard';
import { PlatformTaskCard } from './PlatformTaskCard';

/** All platform-posted "quests" (as opposed to shop-posted tasks), shown at
 * the top of both home feeds so a brand-new user with nothing nearby yet
 * still has something to do. Each card self-hides once its own quest is
 * done/unavailable, so the whole section can end up empty for a
 * fully-onboarded user — that's intended, not a bug. */
export function PlatformQuestsSection() {
  return (
    <View>
      <OnboardingGuideCard />
      <ProfileChecklistCard />
      <AppRatingQuestCard />
      <PlatformTaskCard />
    </View>
  );
}
